// 判断是否退款
export default {
  namespaced: true,
  state: {
    // 判断当前任务是复购，或者其他任务类型
    targetName: '' //
  },
  mutations: {
    SET_TARGETNAME: (state, data) => {
      state.targetName = data
    }
  },
  actions: {
    setRefund ({ commit }, isRefund) {
      commit('SET_REFUND', isRefund)
    }
  }
}